import { render } from "./IncomeAccounting.vue?vue&type=template&id=36d21b9e&scoped=true"
import script from "./IncomeAccounting.vue?vue&type=script&lang=js"
export * from "./IncomeAccounting.vue?vue&type=script&lang=js"

import "./IncomeAccounting.vue?vue&type=style&index=0&id=36d21b9e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d21b9e"]])

export default __exports__